import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Start from "../views/Start";

const routes = [
  {
    path: '/',
    name: 'Start',
    component: Start
  },
  {
    path: '/Home',
    name: 'Home',
    component: Home
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
